let times = function(timess,timestamp){
    var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + " " + h + m + s;
}
let times2 = function(timess,timestamp){
    var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y + M + D;
}
let balance = function(val){
  val = parseFloat(val);
  return val.toFixed(4);
}
let toFixed4 = function(val){
  val = parseFloat(val);
  if(val >= 0){
    val = parseFloat(val);
    return val.toFixed(4);
  }else{
    return '';
  }

}
let mdName = function(str){
  if(!str) return;
  if(str.length >= 8){
      return str.substr(0,4)+'*****'+str.substr(str.split('').length-3)
  }else{
      return str;
  }
}
let toFixed2 = function(val){
  val = Number(val);
  return val.toFixed(2);
}
let rewriteName = function(val){
  let bzName = val;
  if(val == 'CMGCA0'){
    bzName = 'XAU';
    return bzName
  }else if(val == 'CMSIA0'){
    bzName = 'XAG';
    return bzName
  }else{
    return bzName
  }
}
let timeGs = function(val){
 if(val){
  let times = val.split('-');
  let timess = times[2].split(' ');
  let mm = times[1];
  let dd = timess[0];
  let year = times[0];
  let sfm = timess[1];
  return mm + '-' + dd + '-' + year;
 }
}
let timeGs2 = function(val){
  if(val){
   let times = val.split('-');
   let mm = times[1];
   let dd = times[2];
   let year = times[0];
   return mm + '-' + dd + '-' + year
  }
 }
export {times,times2,balance,mdName,toFixed4,toFixed2,rewriteName,timeGs,timeGs2}



// WEBPACK FOOTER //
// ./src/utils/filters.js